import React from 'react';
import { Clock, CheckCircle2, XCircle } from 'lucide-react';

const STATUS_META = {
  planned: { label: 'Gepland', color: 'bg-slate-100 text-slate-700 border-slate-200', icon: Clock },
  worked: { label: 'Gewerkt', color: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: CheckCircle2 },
  approved: { label: 'Goedgekeurd', color: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: CheckCircle2 },
  rejected: { label: 'Niet verschenen', color: 'bg-rose-100 text-rose-700 border-rose-200', icon: XCircle },
};

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || STATUS_META.planned;
  const Icon = meta.icon;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${meta.color}`}
    >
      <Icon size={12} />
      {meta.label}
    </span>
  );
}
